import { StyleSheet } from 'react-native';

export default StyleSheet.create({
    hasOrderLogin: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 36,
        paddingLeft: 12,
        paddingRight: 12,
        backgroundColor: '#fefcec',
        zIndex: 2,
    },
    hasOrderLoginLeft: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
    },
    hasOrderLoginText: {
        fontSize: 13,
        color: '#595452'
    },
    noticeIcon: {
        marginRight: 4,
        width: 20,
        height: 20,
        fontSize: 20,
        color: '#ff9800'
    },
    loginBtn: {
        alignItems: 'center',
        justifyContent: 'center',
        width: 52,
        height: 24,
        borderRadius: 12,
        backgroundColor: '#f5a623'
    },
    loginBtnText: {
        color: '#fff',
        fontSize: 12
    }
});
